module.exports = __webpack_public_path__ + "static/img/wx1.5aa893c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx1.jpg
// module id = 0ElD
// module chunks = 5